// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/PageSpeedInsights/ProgressCircle.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/PageSpeedInsights/ProgressCircle.tsx");
  import.meta.hot.lastModified = "1717182690460.7058";
}
// REMIX HMR END

import clsx from "clsx";
import React, { useMemo } from "react";
const colorMap = {
  healthy: {
    main: "text-secondary-600",
    secondary: "text-secondary-200"
  },
  urgent: {
    main: "text-error-600",
    secondary: "text-error-200"
  },
  warning: {
    main: "text-warning-800",
    secondary: "text-warning-300"
  }
};
const ProgressCircle = ({
  value,
  caption
}) => {
  _s();
  const radius = 35;
  const diameter = radius * 2;
  const stroke = 3;
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const color = useMemo(() => {
    if (value >= 90) return colorMap.healthy;
    if (value >= 50) return colorMap.warning;
    return colorMap.urgent;
  }, [value]);
  return <div className="flex flex-col items-center w-full">
      <p className="relative rounded-full flex items-center justify-center text-xs">
        <svg height={diameter} width={diameter}>
          <circle stroke="currentColor" className={clsx("origin-center rotate-[270deg] fill-transparent", color.secondary)} strokeLinecap="round" strokeDasharray={`${circumference} ${circumference}`} strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />
          <circle stroke="currentColor" className={clsx("origin-center rotate-[270deg] fill-transparent", color.main)} strokeLinecap="round" strokeDasharray={`${circumference} ${circumference}`} style={{
          strokeDashoffset: circumference - Math.floor((typeof value === "number" ? value : 80) / 4) * 4 / 100 * circumference
        }} strokeWidth={stroke} r={normalizedRadius} cx={radius} cy={radius} />
        </svg>
        <span className="absolute text-neutral-600">
          {typeof value === "number" ? value.toFixed(0) : ""}%
        </span>
      </p>
      <span className="text-xs text-primary-700">{caption}</span>
    </div>;
};
_s(ProgressCircle, "/WjuwVs/0HBZwnTqmkaDvvE9h4w=");
_c = ProgressCircle;
export default ProgressCircle;
var _c;
$RefreshReg$(_c, "ProgressCircle");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;